import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Navigate, Outlet } from '@tanstack/react-router';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  // An unknown path is not worth a page of its own in a three-section tool.
  notFoundComponent: () => <Navigate to="/catalog" replace />,
});
